import * as React from 'react';
import styles from './Wrapper.scss';

export const Wrapper =   ({children})  => (
    <div className={styles.Wrapper}>
        {children}
    </div>
);
